<template>
	<div class="flow-dash-card" :state="state">
		<div class="flow-dash-card-title">
			<slot name="title" />
		</div>
		<div class="flow-dash-card-content">
			<slot />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "DashboardCard",
	props: {
		/**
		 * 'light' | 'dark' | 'default' | 'primary' | 'secondary' | 'success' | 'error' | 'warning'
		 */
		state: {
			type: String,
			default: "default",
			validator(value) {
				return [
					"light",
					"dark",
					"default",
					"primary",
					"secondary",
					"success",
					"error",
					"warning",
					"white",
					"black"
				].includes(value);
			}
		}
	}
});
</script>
<style lang="scss">
$dashboard-icon-colors: (
	"light": var(--dashboard-element),
	"dark": var(--dashboard-element-dark),
	"default": var(--dashboard-element-light),
	"primary": var(--dashboard-primary),
	"secondary": var(--dashboard-secondary),
	"success": var(--dashboard-success),
	"error": var(--dashboard-danger),
	"warning": var(--dashboard-warning),
	"white": #fff,
	"black": #000
);
div.flow-dash-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	border-radius: 4px;
	padding: 16px;
	height: 100%;

	@each $state, $color in $dashboard-icon-colors {
		&[state="#{$state}"] {
			background: $color;
		}
	}

	min-width: 100px;
	min-height: 100px;

	> div.flow-dash-card-title {
		padding: 8px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	> div.flow-dash-card-content {
		// padding: 24px;
		flex: 1;
		display: flex;
		align-items: center;
		font-size: 64px;
		line-height: 64px;
	}

	&:active {
		filter: contrast(90%);
	}

	&:hover:not(:active) {
		filter: contrast(95%);
	}

	&:focus {
		box-shadow: inset 0 0 0 2px var(--dashboard-primary);
		outline: none;
	}
}
</style>
